//引入api接口
import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
    // 数据存储对象
    data: () => {
        return {
            /*************************公告信息***************************/
            guid: null, // 主键
            // 项目信息
            detail: {
                /********************* 项目信息 *********************/
                guid: null, // 主键
                method: null, // 处理方式
                title: null, // 标题
                xmlb: null, // 项目类型
                fbksjs: null, // 发布时间
                bdBh: null, // 标段编号
                bdName: null, // 标段名称
                sfbgsj: null, // 是否变更时间
                ggjssj: null, // 公告截止时间
                ysggjssj: null, // 原始公告截止时间
                jjkssj: null, // 竞价开始时间
                ysjjkssj: null, // 原始竞价开始时间
                byfj: null, // 说明
                bgGongShileiXing: null, // 变更类型
                bgNeiRong: null, // 变更内容
                content: null, // 内容
            },
        };
    },
    mounted() {
        // 获取主键
        this.guid = this.$route.query.guid;
        // 获取公告详情
        this.fun_GetDetail();
    },
    // 自定义事件
    methods: {
        /***********************************公告信息**************************************/
        /**
         * 获取公告信息
         */
        fun_GetDetail() {
            // 请求
            fun_PostAction("/hiProcurement/procurementModificationClarificationNoticeDetail", {
                guid: this.guid, // 主键
            }).then(res => {
                // 解构res.data
                const { result, data, msg } = res.data;
                // 解析后台返回的结果集，判断是否成功
                if (result) {
                    // 成功的场景
                    this.detail = data;
                } else {
                    // 请求失败的场景
                    // 请求失败，弹出失败msg的消息提示
                    this.$message.error(msg);
                }
            });
        },
    }
};
